import ItemsV3Adapter from '@square/dashboard-items-data/adapters/items-v3-base';
import { CATALOG_SERVICE_QUERY_TYPES } from '@square/dashboard-data/models/catalog/catalog-service-constants';
import { CategoryType } from '@square/dashboard-items-data/models/category';
export default class Category extends ItemsV3Adapter {
  findAll(store, type) {
    // We want to make sure we are only showing regular categories
    // anywhere categories are listed for Advanced Categories M1
    return this.query(store, type, {
      pageSize: 1000,
      // server has this limit set automatically for find all
      fetchAll: true
    });
  }

  /**
   * We are defaulting to search for REGULAR_CATEGORY categoryType
   * If you need to set a specific type somewhere, please include
   * the appropriate attributeQuery.
   *
   * https://prototype.sqprod.co/#/docs/squareup.items.merchant.GetRequest
   */
  query(store, type, query) {
    const regularCategoryType = [{
      attributeDefinitionTokens: ['SQ_CATEGORY_TYPE'],
      intValue: CategoryType.serialize(CategoryType.REGULAR_CATEGORY)
    }];

    // default category type to REGULAR_CATEGORY if the request does not
    // already specify category type
    const attributeQuery = {
      type: CATALOG_SERVICE_QUERY_TYPES.ATTRIBUTE_VALUES,
      attributeValues: regularCategoryType
    };
    if (query.attributeQueries) {
      const hasCategoryTypeQuery = query.attributeQueries?.some(attrQ => attrQ.type === CATALOG_SERVICE_QUERY_TYPES.ATTRIBUTE_VALUES && attrQ.attributeValues.some(attrV => attrV.attributeDefinitionTokens.contains('SQ_CATEGORY_TYPE')));
      if (!hasCategoryTypeQuery) {
        query.attributeQueries.push(attributeQuery);
      }
    } else {
      query.attributeQueries = [attributeQuery];
    }
    return super.query(store, type, query);
  }
}